import { insertMultiAttachment } from "../../api/ResourceAPI";

const urlRegex = /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;


export const convertUrlsToLinks = (text: string) => { // fungsi untuk mengconvert mengecek url dan mengubahnya menjadi link
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = text;

    const replaceText = (node: Node) => {
        if (node.nodeType === Node.TEXT_NODE) {
            const newFragment = document.createDocumentFragment();
            const matches = node.textContent?.matchAll(urlRegex);
            let lastIndex = 0;

            for (const match of matches || []) {
                const url = match[0];
                const index = match.index!;

                // Add text before the URL
                if (index > lastIndex) {
                    newFragment.appendChild(document.createTextNode(node.textContent!.substring(lastIndex, index)));
                }

                // Add the URL as a link
                const link = document.createElement('a');
                link.href = url;
                link.textContent = url;
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                newFragment.appendChild(link);

                lastIndex = index + url.length;
            }

            // Add any remaining text after the last URL
            if (lastIndex < node.textContent!.length) {
                newFragment.appendChild(document.createTextNode(node.textContent!.substring(lastIndex)));
            }

            node.parentNode?.replaceChild(newFragment, node);
        } else if (node.nodeType === Node.ELEMENT_NODE && node.nodeName !== 'A') {
            Array.from(node.childNodes).forEach(replaceText);
        }
    };

    replaceText(tempDiv);
    return tempDiv.innerHTML;
};

export const processDescriptionImages = async (description: string, token: string): Promise<string> => {
    const base64Regex = /<img[^>]+src="(data:image\/[^;]+;base64,[^"]+)"/g;
    let processedDescription = description;
    const imageFiles: File[] = [];
    const base64Data: string[] = [];

    let match: RegExpExecArray | null;
    let index = 0;
    while ((match = base64Regex.exec(description)) !== null) {
        const fullBase64 = match[1];
        base64Data.push(fullBase64);
        const fileType = fullBase64.split(';')[0].split(':')[1];
        const fileName = `image-${Date.now()}-${index}.${fileType.split('/')[1]}`;

        // Convert base64 to File
        const byteCharacters = atob(fullBase64.split(',')[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const file = new File([byteArray], fileName, { type: fileType });

        imageFiles.push(file);
        index++;
    }

    if (imageFiles.length > 0) {
        try {
            const apiResponse = await insertMultiAttachment(imageFiles, 'PIPELINE', token);

            if (apiResponse.data && apiResponse.data.data && Array.isArray(apiResponse.data.data)) {
                apiResponse.data.data.forEach((fileUrl: string, index: number) => {
                    const originalBase64 = base64Data[index];
                    const replacementURL = `<a href="#" class="image-link text-primary" style="text-decoration: none; cursor: pointer;" onmouseover="this.style.textDecoration='underline'" onmouseout="this.style.textDecoration='none'" data-image-url="${fileUrl}" data-image-index="${index + 1}">Gambar ${index + 1}</a>`;
                    processedDescription = processedDescription.replace(`<img src="${originalBase64}"`, replacementURL);
                    // replace membuang tanda > 
                    processedDescription = processedDescription.replace(/(<a[^>]+>Gambar \d+<\/a>)>/g, '$1');
                });
            } else {
                console.error('Unexpected API response structure:', apiResponse);
            }
        } catch (error) {
            console.error('Failed to upload images:', error);
        }
    }

    return processedDescription;
};

    // eslint-disable-next-line react-hooks/exhaustive-deps
 export async function getBase64(file: Blob): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64String = reader.result as string;
                resolve(base64String);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    }